import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import Github from "../About/Github";
import { FeaturedGithubProjects } from "../About/GithubHighlights";
import { useLanguage } from "../../context/LanguageContext";

function GithubPage() {
  const { t } = useLanguage();

  return (
    <Container fluid className="github-section">
      <Particle />
      <Container>
        <header className="github-page-header">
          <span className="section-eyebrow">{t("github.eyebrow")}</span>
          <h1>
            {t("github.title")} <strong>{t("github.emphasis")}</strong>
          </h1>
          <p>{t("github.subtitle")}</p>
        </header>

        <FeaturedGithubProjects />
        <Github />
      </Container>
    </Container>
  );
}

export default GithubPage;
